import { APP_ID, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { InterceptorServices } from './_Common/_Services/http-interceptors';
import { StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from './helper/reducers';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// import { EffectsModule } from '@ngrx/effects';
// import { AuthEffects } from './ngrx-store/auth/auth.effect';
// import { ExcelImporterEffects } from './ngrx-store/excelImport/excelImport.effect';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideAnimationsAsync(),
    InterceptorServices,
    { provide: APP_ID, useValue: 'MoneytorApp' },
    importProvidersFrom(
      BrowserModule,
      BrowserAnimationsModule,
      StoreModule.forRoot(reducers, {
        metaReducers,
      }),
      NgxEchartsModule.forRoot({
        echarts,
      }),
      StoreDevtoolsModule.instrument({
        maxAge: 25,
        logOnly: false,
        features: {
          pause: false,
          lock: true,
          persist: true,
        },
      }),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
      // EffectsModule.forRoot([AuthEffects, ExcelImporterEffects]),
      StoreRouterConnectingModule.forRoot(),
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: environment.production,
      })
    ),
  ],
};
